<template>
  <div class="stores stores--tabs">
    <div class="field__title">
      Your Nike Store
    </div>
    <div class="field__description">
      Confirm which Nike store is closest to you.
    </div>
    <div class="tabs">
      <div class="tab__nav">
        <div class="tab__state">
          <div
            v-for="(item, nzIndex) in storeSelection.states"
            v-bind:key="`state-${nzIndex}`"
            v-bind:class="{
              'tab__subnav': true,
              'tab__subnav--active': item === tab[storeSelection.country]
            }"
            v-on:click="updateStoreList(item)"
          >
            {{item}}
          </div>
        </div>
      </div>
      <div class="tab-content">
        <div class="tab__content">
          <RadioCheckboxGroup
            v-bind:fieldArray="this.radioGroupStores"
            type="radio"
            v-bind:initial="initial"
            v-bind:initialStoreName="initialStoreName"
            v-model="selectedClosetStore"
            validate="required"
            errorMsg="Please select a preference."
            classname="store field__radio--store"
          />
          <div class="is-danger" v-show="errors.has('closestStore')">
            Please select a preference.
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
// Mixin
import fieldWrap from '@/components/mixin/fieldWrap';

// Data
import auStoreData from '@/data/au-stores.json';
import nzStoreData from '@/data/nz-stores.json';
import userData from '@/data/user-data.json';

// Components
import StoreItem from '@/components/stores/StoreItem.vue';
import RadioCheckboxGroup from '@/components/fields/RadioCheckboxGroup.vue';

export default {
  name: 'StoresTab',
  mixins: [fieldWrap],
  props: [
    'initial',
    'locale',
  ],
  components: {
    StoreItem,
    RadioCheckboxGroup,
  },
  data() {
    return {
      storeSelection: [{
        states: [],
        stores: [],
      }],
      tab: {
        country: this.locale.toLowerCase() ? this.locale.toLowerCase() : 'au',
        au: 'VIC',
        nz: 'NZ',
      },
      auStores: auStoreData.auStores,
      nzStores: nzStoreData.nzStores,
      userData: userData.user,
      selectedClosetStore: '',
      radioGroupStores: [],
      initialStoreName: '',
    };
  },
  created() {
    // this.getStores('au');
    this.getStores(this.tab.country);
  },
  methods: {
    updateStoreList(state) {
      const locale = this.locale.toLowerCase() ? this.locale.toLowerCase() : 'au';

      this.tab[locale] = state;
      this.getStores(locale);
    },
    getStores(country) {
      const self = this;
      const selectedState = this.tab[country];
      const stores = country === 'au' ? this.auStores : this.nzStores;
      const filteredStores = stores.filter(store => store.state === selectedState);

      const storeList = filteredStores[0].stores.map((store) => {
        const storeItem = store;

        storeItem.selected = storeItem.name === self.userData.closestStore;

        return storeItem;
      });

      this.storeSelection = {
        country,
        stores: storeList,
      };

      if (selectedState !== 'NZ') {
        const states = stores.map(store => store.state);
        this.storeSelection.states = states;
      }

      this.radioGroupStores = [];
      this.storeSelection.stores.forEach((_store) => {
        if (this.initial === _store.value) {
          this.initialStoreName = _store.name;
        }

        this.radioGroupStores.push({
          label: {
            store: _store,
          },
          name: 'stores',
          value: _store.value,
        });
      });
    },
    getStoreField(storeName) {
      return {
        mandatory: false,
        inline: true,
        type: 'radio',
        name: 'closestStore',
        label: true,
        classname: 'field__radio--store',
        value: storeName,
      };
    },
  },
  watch: {
    selectedClosetStore(value) {
      this.selectedClosetStore = value;
      // console.log('watch change: ', this.selectedClosetStore);
      this.$emit('input', this.selectedClosetStore);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import "@/assets/scss/settings.scss";

$radio-icon-width: 16px;
$store-gap: $spacing;
$store-nav-gap: $spacing-double;
$store-padding: $spacing-half;
// Default label padding top: 10px;
$radio-label-padding-top: $store-padding;
$radio-icon-gap: 4px;

$tab-border-color: #e5e5e5;
$tab-nav-border: $charcoal;
$tab-state-color: #9b9b9b;
$tab-state-selected-color: $body-text;

// Custom styles
.field__radio--store {
  .label {
    padding-top: $radio-label-padding-top;
    padding-left: $radio-icon-width + $store-padding;

    &:before {
      top: $radio-label-padding-top + 3px;
      transform: none;
    }

    &:after {
      top: $radio-label-padding-top + 3px + $radio-icon-gap;
      left: 4px;
      transform: none;
    }
  }
}

.tab__navitem {
  width: 50%;
  @include nike-heading;
  font-size: $title-font-size;
  line-height: $title-line-height;
}

.tab__navname {
  position: relative;
  display: inline-block;
  padding: $store-padding 0;
  cursor: pointer;

  &:after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 2px;
    background: none;
  }
}

.tab__navitem--active {
  .tab__navname:after {
    background-color: $tab-nav-border;
  }
}

.tab__state {
  display: flex;
  padding: $store-padding 0;
}

.tab__subnav {
  padding: $store-padding 0;
  margin-right: $store-gap;
  @include nike-heading;
  font-size: $title-font-size;
  line-height: $title-line-height;
  color: $tab-state-color;
  cursor: pointer;

  @include small-up {
    margin-right: $store-nav-gap;
  }
}

.tab__subnav--active {
  color: $tab-state-selected-color;
}

.tab__content > .field-set__fields {
  @include small-up {
    display: flex;
    flex-wrap: wrap;
  }

  .field__radio {
    .is-danger {
      display: none;
    }
  }

  .is-danger {
    padding-top: 0;
    margin-top: -7px;
  }
}

.store {
  @include small-up {
    width: 50%;
  }
}
</style>
